import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import React from 'react';

import Text from 'Pages/Home/Components/Atoms/Text';
import { joinClassnames } from 'helpers/classNames';
import Styles from './ButtonCard.module.scss';
import { TButtonCard } from './definitions';

const ButtonCard: React.FC<TButtonCard> = ({
  text,
  bold,
  withX,
  className,
  onClick,
  onClickX,
  eventCard,
  isFetching,
}) => {
  const renderInnerContent = () => {
    if (!withX)
      return (
        <Row justify="space-around" align="middle">
          <Text
            className={joinClassnames(
              Styles['button-card-text'],
              bold && Styles['bold'],
            )}
          >
            {text}
          </Text>
          {isFetching && (
            <LoadingOutlined
              style={{ color: '#079a5a', fontWeight: 'bolder', marginLeft: 8 }}
            />
          )}
        </Row>
      );

    return (
      <Row justify="space-around" align="middle">
        <Text className={Styles['button-card-text']} onClick={onClick}>
          {text}
        </Text>
        <CloseOutlined
          className={Styles['button-card-icon']}
          onClick={onClickX}
        />
      </Row>
    );
  };

  return (
    <Col
      className={joinClassnames(
        Styles['button-card'],
        className ? className : '',
        eventCard && Styles['event-card'],
      )}
      onClick={withX ? () => {} : onClick}
    >
      {renderInnerContent()}
    </Col>
  );
};

export default ButtonCard;
